"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeMultiSend = void 0;
const ethers_1 = require("ethers");
const ethers_contracts_1 = require("../types/ethers-contracts");
const void_1 = require("./void");
const MULTI_SEND_ADDR = "0x8D29bE29923b68abfDD21e541b9374737B49cdAD";
const voidMultisend = ethers_contracts_1.MultiSend__factory.connect(MULTI_SEND_ADDR, void_1.voidSigner);
const removeHexPrefix = (input) => input.toLowerCase().startsWith("0x") ? input.slice(2) : input;
const encodeData = function (operation, to, value, data) {
    let dataBuffer = Buffer.from(removeHexPrefix(data), "hex");
    return removeHexPrefix(ethers_1.utils.solidityPack(["uint8", "address", "uint256", "uint256", "bytes"], [
        operation,
        to,
        ethers_1.BigNumber.from(value).toHexString(),
        dataBuffer.length,
        dataBuffer,
    ]));
};
async function encodeMultiSend(transactions) {
    const data = transactions.map((tx) => {
        return encodeData(0, tx.to || void_1.addr0, tx.value || 0, tx.data || '0x00'); // currently only supporting call and not delegate call
    }).join('');
    return voidMultisend.populateTransaction.multiSend('0x' + data);
}
exports.encodeMultiSend = encodeMultiSend;
